/* PSC redesign helpers (Oct 2026). Loaded with defer on product pages.
 * Delivery estimate: turns "Pristatymas per 7 iki 15 darbo dienų" into real dates
 * (today plus 7 to 15 working days, Monday to Friday), the same window checkout shows.
 * Horizon re-renders the product section on variant change, so it re-applies on DOM changes. */
(function () {
  var LT = ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'];
  var EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addWorkdays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fmt(a, b, lang) {
    var lt = lang.indexOf('lt') === 0;
    var M = lt ? LT : EN;
    if (a.getMonth() === b.getMonth()) {
      return lt ? 'nuo ' + M[a.getMonth()] + ' ' + a.getDate() + ' iki ' + b.getDate() + ' d.' : M[a.getMonth()] + ' ' + a.getDate() + ' to ' + b.getDate();
    }
    return lt
      ? 'nuo ' + M[a.getMonth()] + ' ' + a.getDate() + ' d. iki ' + M[b.getMonth()] + ' ' + b.getDate() + ' d.'
      : M[a.getMonth()] + ' ' + a.getDate() + ' to ' + M[b.getMonth()] + ' ' + b.getDate();
  }

  function apply() {
    var nodes = document.querySelectorAll('[data-psc-eta]:not([data-psc-eta-done])');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var now = new Date();
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 15;
      var lang = el.getAttribute('data-lang') || 'lt';
      var prefix = el.getAttribute('data-prefix') || '';
      el.textContent = prefix + ' ' + fmt(addWorkdays(now, min), addWorkdays(now, max), lang);
      el.setAttribute('data-psc-eta-done', '');
    }
  }

  apply();
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();
